module.exports = __webpack_public_path__ + "img/18.7820d4db.jpg";